import { render, staticRenderFns } from "./app-area-list.vue?vue&type=template&id=dbf1bdba&scoped=true&"
import script from "./app-area-list.vue?vue&type=script&lang=js&"
export * from "./app-area-list.vue?vue&type=script&lang=js&"
import style0 from "./app-area-list.vue?vue&type=style&index=0&id=dbf1bdba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf1bdba",
  null
  
)

export default component.exports